module.exports = __webpack_public_path__ + "static/media/mianshidengji1.ae32b9a0.png";